import { render, staticRenderFns } from "./TotalCostMetricConfigurationPage.vue?vue&type=template&id=8c0d6610"
import script from "./TotalCostMetricConfigurationPage.vue?vue&type=script&lang=ts"
export * from "./TotalCostMetricConfigurationPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports